module.exports = __webpack_public_path__ + "assets/img/5-avantages-GED.5a1157eb.jpg";